import { useEffect } from 'react';

interface AddressSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddressSelected: (addressData: {
    roadAddress: string;
    jibunAddress: string;
    zonecode: string;
  }) => void;
}

export function AddressSearchModal({
  isOpen,
  onClose,
  onAddressSelected
}: AddressSearchModalProps) {
  useEffect(() => {
    if (isOpen) {
      // Daum Postcode API 로드 확인
      const loadDaumPostcode = () => {
        if (window.daum && window.daum.Postcode) {
          // 팝업 방식으로 주소 검색 열기
          new window.daum.Postcode({
            oncomplete: function(data: any) {
              // 선택된 주소 데이터 처리
              const addressData = {
                roadAddress: data.roadAddress || data.autoRoadAddress,
                jibunAddress: data.jibunAddress || data.autoJibunAddress,
                zonecode: data.zonecode
              };
              
              onAddressSelected(addressData);
              onClose();
            },
            onclose: function() {
              onClose();
            }
          }).open();
        } else {
          // 스크립트가 아직 로드되지 않은 경우
          const script = document.createElement('script');
          script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
          script.onload = () => {
            if (window.daum && window.daum.Postcode) {
              new window.daum.Postcode({
                oncomplete: function(data: any) {
                  const addressData = {
                    roadAddress: data.roadAddress || data.autoRoadAddress,
                    jibunAddress: data.jibunAddress || data.autoJibunAddress,
                    zonecode: data.zonecode
                  };
                  
                  onAddressSelected(addressData);
                  onClose();
                },
                onclose: function() {
                  onClose();
                }
              }).open();
            }
          };
          document.head.appendChild(script);
        }
      };
      
      loadDaumPostcode();
    }
  }, [isOpen, onAddressSelected, onClose]);

  // 팝업 방식이므로 실제 모달 UI는 필요 없음
  return null;
}

// Daum Postcode API 타입 선언
declare global {
  interface Window {
    daum: {
      Postcode: new (options: {
        oncomplete: (data: any) => void;
        onclose?: () => void;
        width?: string;
        height?: string;
      }) => {
        embed: (element: HTMLElement) => void;
        open: () => void;
      };
    };
  }
}